import axios from 'axios';
import * as _ from 'underscore';

var globalData = {};

export default class MenuXMLParser {

    init (url) {
        return axios.get(url).then(this.convertToJSON);
    }

    convertToJSON (response) {
        // var doc = .parseFromString(response.data, 'text/xml');
        if (window.DOMParser){
            var doc = (new DOMParser()).parseFromString(response.data, 'text/xml');
        } else {
            // Internet Explorer
            var doc = new ActiveXObject("Microsoft.XMLDOM");
            doc.async = false;
            doc.loadXML(response.data);
        }

        var data = {
            restaurant: {
                name: doc.getElementsByTagName('NewDataSet')[0].getElementsByTagName('Header')[0].getElementsByTagName('BillOfFareName')[0].textContent.trim(),
                address: doc.getElementsByTagName('NewDataSet')[0].getElementsByTagName('Header')[0].getElementsByTagName('Kitchen')[0].getElementsByTagName('Address')[0].textContent.trim()
            },
            days: []
        };

        var dayNodes = doc.getElementsByTagName('NewDataSet')[0].getElementsByTagName('WeekDays')[0].childNodes;

        for (var dayIndex = 0; dayIndex < dayNodes.length; dayIndex++) {
            var dayNode = dayNodes[dayIndex];
            if(dayNode.nodeType == 1) {
                var day = {
                    date: dayNode.getAttribute('Date'),
                    menus: [] 
                };

                var lines = dayNode.childNodes;
                for (var l = 0; l < lines.length; l++) {
                    if(lines[l].nodeType == 1) {
                        var menus = lines[l].getElementsByTagName('SetMenu');

                        for (var i = 0; i < menus.length; i++) {
                            if(menus[i].nodeType == 1) {
                                var nutrition = _.pluck(xmlToJson(menus[i].getElementsByTagName('SetMenuDetails')[0].getElementsByTagName('NutritionInfo')[0]).Nutrient, '@attributes');

                                var additivesXML = menus[i].getElementsByTagName('SetMenuDetails')[0].getElementsByTagName('AdditiveInfo')[0].getElementsByTagName('AdditiveGroup')[0];
                                var additives = [];
                                var additive;
                                if(additivesXML !== undefined && additivesXML.children !== undefined) {
                                    additive = xmlToJson(additivesXML).Additive;
                                    additives = _.pluck((Array.isArray(additive) ? additive : [additive]), '@attributes');
                                }

                                var menu = {
                                    type: menus[i].getAttribute('Name').trim(),
                                    price: menus[i].getAttribute('SalesPrice').trim(),
                                    //price_backed: menus[i].getElementsByTagName('SetMenuDetails')[0].getElementsByTagName('ProductInfo')[0].getElementsByTagName('Product')[0].getAttribute('ProductPrice2').trim(),
                                    category: menus[i].getAttribute('Name').trim(),
                                    meal: menus[i].getElementsByTagName('SetMenuDetails')[0].getElementsByTagName('GastDesc')[0].getAttribute('value').trim(),
                                    nutrition: nutrition,
                                    additives: additives,
                                    show_additional: false,
                                };

                                day.menus.push(menu);
                            }
                        }
                    }
                }

                data.days.push(day);
            }
        }

        globalData = data;
        return data;
    }

    getData () {
        return globalData;
    }
}

// Changes XML to JSON
var xmlToJson = function(xml) {
    
    // Create the return object
    var obj = {};

    if (xml.nodeType == 1) { // element
        // do attributes
        if (xml.attributes.length > 0) {
        obj["@attributes"] = {};
            for (var j = 0; j < xml.attributes.length; j++) {
                var attribute = xml.attributes.item(j);
                obj["@attributes"][attribute.nodeName] = attribute.nodeValue;
            }
        }
    } else if (xml.nodeType == 3) { // text
        obj = xml.nodeValue;
    }

    // do children
    if (xml.hasChildNodes()) {
        for(var i = 0; i < xml.childNodes.length; i++) {
            var item = xml.childNodes.item(i);
            var nodeName = item.nodeName;
            if (typeof(obj[nodeName]) == "undefined") {
                obj[nodeName] = xmlToJson(item);
            } else {
                if (typeof(obj[nodeName].push) == "undefined") {
                    var old = obj[nodeName];
                    obj[nodeName] = [];
                    obj[nodeName].push(old);
                }
                obj[nodeName].push(xmlToJson(item));
            }
        }
    }
    return obj;
}



// WEBPACK FOOTER //
// ./src/MenuXMLParser.js